export default __webpack_public_path__ + "static/media/momentocard_preview.56c3e74c.png";